import { ThemeConfig } from 'antd';

/**
 * Paleta do site. As mesmas cores estao como variaveis CSS no `:root`
 * (`styles/themes/_themes.scss` e `main.css`, prefixo `--cor-`); aqui elas vao
 * para o antd, que nao le variavel CSS nos tokens.
 *
 * Roxo da marca, azul-ardosia dos botoes de acao, dourado de destaque, cinzas
 * de texto e fundo, e branco nas superficies.
 */
export const CORES = {
    marca: '#3B3348',
    marcaClara: '#4a4059',
    azul: '#465F70',
    ouro: '#d9aa38',
    ouroEscuro: '#b8862b',
    ouroClaro: '#e6c46e',
    texto: '#26222e',
    textoForte: '#1f1b27',
    texto2: '#6b6676',
    texto3: '#8a8494',
    fundo: '#DEDDE0',
    superficie: '#ffffff',
    selecionado: '#efecf4',
    selecionadoHover: '#e5e0ed',
} as const;

/**
 * Tema do antd para o site inteiro: botoes, campos, seletores, abas e
 * paginacao na cor da marca, em vez do azul padrao da biblioteca.
 */
export const TEMA_DO_SITE: ThemeConfig = {
    token: {
        colorPrimary: CORES.marca,
        colorLink: CORES.marca,
        colorLinkHover: CORES.marcaClara,
        colorTextBase: CORES.texto,
        borderRadius: 8,
        fontFamily: "'Roboto', system-ui, -apple-system, 'Segoe UI', sans-serif",
        /*
         * Fundo de item selecionado (opcoes marcadas num seletor, item ativo de
         * menu). O antd deriva esse tom da cor primaria, e para um roxo tao
         * escuro e acinzentado o resultado era um cinza pesado atras de texto
         * preto. Fixado num lilas bem claro.
         */
        controlItemBgActive: CORES.selecionado,
        controlItemBgActiveHover: CORES.selecionadoHover,
        colorPrimaryBg: CORES.selecionado,
        colorPrimaryBgHover: CORES.selecionadoHover,
    },
};
